import { Injectable } from '@angular/core';
import { environment } from '@env';

@Injectable({
  providedIn: 'root',
})
export class ConfigService {
  get isProduction(): boolean {
    return environment.production;
  }

  get ENV(): string {
    return environment.ENV;
  }

  get BASE_BACKEND(): string {
    return environment.BASE_BACKEND;
  }

  get INDIVIDEO_DEPLOYMENT_CODE(): string {
    return environment.INDIVIDEO_DEPLOYMENT_CODE;
  }

  get INDIVIDEO_URL(): string {
    return environment.INDIVIDEO_URL;
  }

  get RECAPTCHA_KEY(): string {
    return String(environment.RECAPTCHA_KEY);
  }

  get ENABLE_RECAPTCHA(): boolean {
    return environment.ENABLE_RECAPTCHA;
  }

  get LOGROCKET_APP_ID(): string {
    return environment.LOGROCKET_APP_ID;
  }

  get ENABLE_LOGROCKET(): boolean {
    return environment.ENABLE_LOGROCKET;
  }
}
